import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_URL, BannerFormData, EditionArticleFormData } from './base/interfaces';
import { AuthService } from './auth.service';
import { AngularFirestore, CollectionReference, Query } from '@angular/fire/firestore';
import { Banner } from './shared/intefaces/banner';

@Injectable({
  providedIn: 'root'
})
export class BannerService {

  url = `${API_URL}banner`;

  constructor(private http: HttpClient, private auth: AuthService, private firestore: AngularFirestore) { }

  get options(): any {
    return {
      'headers': {
        // 'Athorization': `Bearer${this.auth.token}`
      }
    };
  }

  public list(entry: any, position: string, status: boolean, direction: string) {
    return this.firestore.collection<Banner>('banners', ref => {
      let query: CollectionReference | Query = ref;

      query = query.where('published', '==', status)
        .where('position', '==', position)
        .orderBy('title', 'desc');

      if (entry) {
        if (direction === 'before') {
          query = query.endBefore(entry).limitToLast(20);
        } else {
          query = query.startAfter(entry).limit(20);
        }
      } else {
        query = query.limit(20);
      }

      return query;
    }).get();
  }

  public getById(id: string) {
    return this.firestore.collection('banners').doc(id).get();
  }

  public get(id: string) {
    return this.http.get(`${this.url}/get/${id}`, this.options);
  }

  public create(id: string, data: any) {
    return this.firestore.collection('banners').doc(id).set(data);
  }

  public update(id: string, data: any) {
    return this.firestore.collection('banners').doc(id).update(data);
  }

  public delete(id: string) {
    return this.firestore.collection('banners').doc(id).delete();
  }

  public togglePublish(id: string, published: boolean) {
    const data = {
      published: !published
    };

    return this.firestore.collection('banners').doc(id).update(data);
  }

}
